import {createAsyncThunk} from "@reduxjs/toolkit";
import {USER_LOCALSTORAGE_KEY} from "../../../../../shared/const/localstorage";
import axios, {AxiosError} from "axios";
import {setLessonsData} from "../../../slice/student-info/StudentInfoLessonsSlice";
import {createRequestParams} from "../../../../../common/hook/create-request-params/createRequestParams";
import {setNotFoundError} from "features/model/slice/error/errorSlice";


interface StudentInfoParams {
    groupId: string | undefined;
    studentId: string | undefined;
    from?: string;
    to?: string;
    page?: number;
}


export const fetchStudentLessons = createAsyncThunk(
    "student/fetchStudentHomeworks",
    async ({groupId, studentId, from, to, page}: StudentInfoParams, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const {token} = JSON.parse(authToken);

            const params = createRequestParams(from, to, page);

            const response = await axios.get(`/api/groups/${groupId}/student-info/${studentId}/lessons`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params,
                }
            );

            if (!response.data) {
                throw new Error("Response data is empty");
            }

            if (response.data.success) {
                thunkAPI.dispatch(setLessonsData(response.data.data));
            }

            return response.data;
        } catch (error) {
            thunkAPI.dispatch(setNotFoundError((error as AxiosError).response!.status));
        }
    }
);
